import { render } from "./MultipleSearch.vue?vue&type=template&id=bd88b956&scoped=true"
import script from "./MultipleSearch.vue?vue&type=script&lang=js"
export * from "./MultipleSearch.vue?vue&type=script&lang=js"

import "./MultipleSearch.vue?vue&type=style&index=0&id=bd88b956&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd88b956"]])

export default __exports__